import { useMemo } from "react";

import InstitutionDevicesStyle from "./style";
import InstitutionDevicesTable from "./table";
import { createData } from "./helper";

import { useInstitutionDevices } from "@/api/hooks/institution";

export default function InstitutionDevices({ institutionId }: { institutionId: number }) {
    const { data: devices, isLoading, isFetching } = useInstitutionDevices(institutionId);

    const DeviceData = useMemo(() => (devices ? devices.data.items.map((item) => createData(item)) : []), [devices]);

    return (
        <InstitutionDevicesStyle>
            <InstitutionDevicesTable
                data={DeviceData}
                institutionId={institutionId}
                isFetching={isFetching}
                isLoading={isLoading}
            />
        </InstitutionDevicesStyle>
    );
}
